import { useState, useEffect } from 'react';
import { supabaseGetter } from '~/api/supabase-getter';

/**
 * Hook to fetch crop template collection types
 * @returns {Object} Collection types, loading state, and error
 */
export const useCollectionTypes = () => {
  const [collectionTypes, setCollectionTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError(null);

      try {
        const { data, error: fetchError } =
          await supabaseGetter.cropTemplateCollectionTypes.getAll();

        if (fetchError) throw fetchError;

        setCollectionTypes(data || []);
      } catch (err) {
        console.error('Error fetching collection types:', err);
        setError(err.message);
        setCollectionTypes([]);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  return {
    collectionTypes,
    loading,
    error,
    invalidate: () => {
      supabaseGetter.cropTemplateCollectionTypes.invalidate();
    }
  };
}
